var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02327 12C4.72379 12 4.27456 11.8503 3.97508 11.5508L0.3813 7.35803C-0.217664 6.75907 -0.0679228 5.86062 0.531041 5.26166C1.13 4.6627 2.02845 4.81244 2.62741 5.4114L5.17301 8.25648L12.0611 0.469953C12.6601 -0.129011 13.5585 -0.129011 14.1575 0.320212C14.7564 0.919175 14.7564 1.81762 14.3072 2.41658L6.22119 11.401C5.92171 11.8503 5.47249 12 5.02327 12Z",
    fill: "#A3FF12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/checkicon.7ffe503992611c03074152bcc7d8288e.svg";
export { ForwardRef as ReactComponent };